import { OrderSelectionPopup } from './orderSelection.popup.tsx';

export const orderSelectionPopup = new OrderSelectionPopup();
